import Vue from 'vue';
import { IonicVueRouter } from '@modus/ionic-vue';

import auth from './auth/routes'
import bridge from './bridge/routes'
import commits from './commits/routes'
import releases from './releases/routes'
import inventory from './inventory/routes'
import store from './state'

Vue.use(IonicVueRouter)

const router = new IonicVueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    { path: '/', redirect: { name: 'bridges'} },
    ...auth,
    ...bridge,
    ...commits,
    ...releases,
    ...inventory
  ]
})

router.beforeEach(checkRequireLogin)
router.beforeEach(checkRequireNoLogin)

function checkRequireLogin(to, from, next) {
  if(!to.meta || to.meta.requireLogin === false) {
    return next()
  }

  if(!store.getters.isLoggedIn) {
    return next({ name: 'login' })
  }

  next()
}

function checkRequireNoLogin(to, from, next) {
  if(!to.meta || to.meta.requireNoLogin !== true) {
    return next()
  }

  if(store.getters.isLoggedIn) {
    return next({ name: 'bridges' })
  }

  next()
}

export default router